import { 
  getStatistics,
  getDashboardStats, 
  getUserStats, 
  getIpStats, 
  getTrendStats,
  getAlerts 
} from '@/api/dashboard'

const state = {
  statistics: {
    financeInfo: {
      accountBalance: 0,
      transactionAmountToday: 0,
      transactionAmountYesterday: 0,
      transactionAmountThisMonth: 0,
      transactionAmountLastMonth: 0
    },
    userRegisterInfo: {
      registerUserCount: 0,
      registerUserCountToday: 0,
      registerUserCountYesterday: 0,
      registerUserCountThisMonth: 0,
      registerUserCountLastMonth: 0
    }
  },
  userStats: {
    todayActiveUsers: 0,
    monthActiveUsers: 0,
    todayNewUsers: 0,
    monthNewUsers: 0,
    totalUsers: 0
  },
  ipStats: {
    totalIps: 0,
    activeIps: 0,
    usageRate: 0
  },
  trends: {
    consume: [],
    ipUsage: [],
    userGrowth: []
  },
  alerts: []
}

const mutations = {
  SET_STATISTICS: (state, data) => {
    state.statistics = data
  },
  SET_USER_STATS: (state, stats) => {
    state.userStats = stats
  },
  SET_IP_STATS: (state, stats) => {
    state.ipStats = stats
  },
  SET_TRENDS: (state, trends) => {
    state.trends = trends
  },
  SET_ALERTS: (state, alerts) => {
    state.alerts = alerts
  }
}

const actions = {
  // 获取统计数据
  async getStatistics({ commit }) {
    const res = await getStatistics()
    if (res.code === 200) {
      commit('SET_STATISTICS', res.data)
    }
    return res
  },
  // 获取仪表盘统计数据（mock）
  async getDashboardStats({ commit }) {
    const res = await getDashboardStats()
    commit('SET_STATISTICS', res)
    return res
  },
  // 获取用户统计数据
  async getUserStats({ commit }) {
    const res = await getUserStats()
    commit('SET_USER_STATS', res)
    return res
  },
  // 获取IP统计数据
  async getIpStats({ commit }) {
    const res = await getIpStats()
    commit('SET_IP_STATS', res)
    return res
  },
  // 获取趋势数据
  async getTrendStats({ commit }, params) {
    const res = await getTrendStats(params)
    commit('SET_TRENDS', res)
    return res
  },
  // 获取告警信息
  async getAlerts({ commit }) {
    const res = await getAlerts()
    commit('SET_ALERTS', res)
    return res
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
